import axios from "axios";
import { API } from "../config";

import {
  PRODUCT_SEARCH_REQUEST,
  PRODUCT_SEARCH_FAILURE,
  PRODUCT_SEARCH_SUCCESS,
  CATEGORIES_LIST_FAILURE,
  CATEGORIES_LIST_REQUEST,
  CATEGORIES_LIST_SUCCESS,
  PRODUCT_DELETE_FAILURE,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  SUB_CATEGORIES_LIST_FAILURE,
  SUB_CATEGORIES_LIST_REQUEST,
  SUB_CATEGORIES_LIST_SUCCESS,
  PRODUCT_UPDATE_FAILURE,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_DETAIL_REQUEST,
  PRODUCT_DETAIL_SUCCESS,
  PRODUCT_DETAIL_FAILURE,
  PRODUCT_CREATE_FAILURE,
  PRODUCT_CREATE_REQUEST,
  PRODUCT_CREATE_SUCCESS,
  SPP_CREATE_REQUEST,
  SPP_CREATE_FAILURE,
  SPP_CREATE_SUCCESS,
} from "../constants/productConstants";

export const getProducts = (search) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_SEARCH_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    const { data } = await axios.get(
      `${API}/api/products/product-detail/?name=${search}`,
      config
    );
    console.log(data);
    dispatch({
      type: PRODUCT_SEARCH_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_SEARCH_FAILURE,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
export const getProductDetail = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_DETAIL_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    const { data } = await axios.get(
      `${API}/api/products/product-detail/${id}`,
      config
    );
    dispatch({
      type: PRODUCT_DETAIL_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAIL_FAILURE,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
export const getCategories = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: CATEGORIES_LIST_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    const { data } = await axios.get(
      `${API}/api/products/categories/?is_active=true`,
      config
    );
    dispatch({
      type: CATEGORIES_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORIES_LIST_FAILURE,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
export const getSubCategories = (cat_id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SUB_CATEGORIES_LIST_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    const { data } = await axios.get(
      `${API}/api/products/sub-categories/?category=${cat_id}`,
      config
    );
    dispatch({
      type: SUB_CATEGORIES_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SUB_CATEGORIES_LIST_FAILURE,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
export const deleteProduct = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_DELETE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    await axios.delete(`${API}/api/products/products/${id}`, config);

    dispatch({
      type: PRODUCT_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DELETE_FAILURE,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
export const updateProduct = (productData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_UPDATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    const { data } = await axios.put(
      `${API}/api/products/products/${productData.id}/`,
      productData,
      config
    );
    dispatch({
      type: PRODUCT_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_UPDATE_FAILURE,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

export const createProduct = (productData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_CREATE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();
    console.log(productData);
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };

    const { data } = await axios.post(
      `${API}/api/products/products/`,
      productData,
      config
    );
    // console.log(data);
    // const response = await axios.post(
    //   `${API}/api/products/store-product-price/`,
    //   {
    //     outlet: 1,
    //     product: data.data.id,
    //     price: productData.price,
    //   },
    //   config
    // );
    // const responseData = await response.data;
    // console.log(responseData);

    dispatch({
      type: PRODUCT_CREATE_SUCCESS,
      payload: data["message"],
      productId: data.data.id,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_CREATE_FAILURE,
      payload: "Couldn't create product",
    });
  }
};

export const createSPP =
  (storeProductPrice, productId, price) => async (dispatch, getState) => {
    storeProductPrice.forEach(async (spp) => {
      try {
        dispatch({
          type: SPP_CREATE_REQUEST,
        });
        const {
          userLogin: { userInfo },
        } = getState();

        const config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        };
        const response = await axios.post(
          `${API}/api/products/store-product-price/`,
          {
            outlet: spp.value,
            product: productId,
            price: price,
          },
          config
        );
        const data = await response.data;
        console.log(data.data);

        dispatch({
          type: SPP_CREATE_SUCCESS,
          payload: data["message"],
          sppData: data.data,
        });
      } catch (error) {
        dispatch({
          type: SPP_CREATE_FAILURE,
          payload: error,
        });
      }
    });
  };

export const editSPP = (activeSPP) => async (dispatch, getState) => {
  console.log(activeSPP);
  try {
    dispatch({
      type: SPP_CREATE_REQUEST,
    });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access_token}`,
      },
    };
    const response = await axios.put(
      `${API}/api/products/store-product-price/${activeSPP.id}/`,
      {
        outlet: activeSPP.outlet,
        price: activeSPP.price,
        product: activeSPP.product,
      },
      config
    );
    const data = await response.data;
    console.log(data.data);

    dispatch({
      type: SPP_CREATE_SUCCESS,
      payload: data["message"],
      sppData: data.data,
    });
  } catch (error) {
    dispatch({
      type: SPP_CREATE_FAILURE,
      payload: error,
    });
  }
};
